import { useEffect, useRef, useState } from "react";
import * as S from "./styles";

const items = [
  { value: "20+", label: "Anos de experiência" },
  { value: "500+", label: "Clientes atendidos" },
  { value: "1.8k+", label: "Projetos entregues" },
  { value: "150k+", label: "Usuários usam nossa tecnologia" }, // conta até 150 e exibe k+
];

export const StatsSection = () => {
  const rootRef = useRef(null);
  const [start, setStart] = useState(false);

  useEffect(() => {
    const el = rootRef.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setStart(true); io.disconnect(); }
    }, { threshold: 0.35 });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <S.Wrapper ref={rootRef}>
      <h3>De desafios a conquistas</h3>

      <S.StatisBox>
        {items.map((it, i) => (
          <div className={`cell ${start ? 'in' : ''}`} key={i}>
            <p className="value">
              <Counter value={it.value} run={start} duration={1100} />
            </p>
            <p className="label">{it.label}</p>
            {i < items.length - 1 && <span className="divider" />}
          </div>
        ))}
      </S.StatisBox>
    </S.Wrapper>
  );
};

function Counter({ value, run, duration = 1100 }) {
  const conf = parseValue(value);
  const [n, setN] = useState(0);
  const raf = useRef();

  useEffect(() => {
    if (!run) return;

    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
      setN(conf.target);
      return;
    }

    const t0 = performance.now();
    const tick = (t) => {
      const k = Math.min(1, (t - t0) / duration);
      const e = 1 - Math.pow(1 - k, 3);
      setN(conf.target * e);
      if (k < 1) raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [run, duration, conf.target]);

  return <>{formatValue(n, conf)}</>;
}

function parseValue(raw) {
  const s = String(raw).trim();
  const m = s.match(/^(\d+(?:[.,]\d+)?)(\s*[kmb])?(\+)?$/i);
  if (!m) return { target: Number(s) || 0, unit: "", plus: "", decimals: 0 };
  const numPart = m[1].replace(",", ".");
  const unit = (m[2] || "").trim().toLowerCase();
  const plus = m[3] ? "+" : "";
  const decimals = (numPart.split(".")[1] || "").length;

  return { target: Number(numPart), unit, plus, decimals };
}

function formatValue(n, { unit, plus, decimals }) {
  let out = decimals > 0 ? n.toFixed(decimals) : Math.round(n).toString();
  if (decimals > 0) out = out.replace(/\.0+$/, (m) => (m === ".0" ? "" : m));
  return `${out}${unit}${plus}`;
}
